// extracted by mini-css-extract-plugin
module.exports = {"suggest":"_9400a595a7--suggest--I_rPq","suggest-item":"_9400a595a7--suggest-item--VZXnw","suggest-error":"_9400a595a7--suggest-error--QhoTR"};